export const PAGEVIEW = {
  eventName: 'PageView',
  type: 'Page',
};

export const CLICK = {
  eventName: 'Click',
};

export const IMPRESSION = {
  eventName: 'Impression',
};

export const SUBMIT = {
  eventName: 'Submit',
};

export const SEARCH = {
  eventName: 'Search',
};

export const PURCHASE = {
  eventName: 'Purchase',
};

export const FOCUS = {
  eventName: 'Focus',
};

export const CHANGE = {
  eventName: 'Change',
};
